import {useCallback, useEffect, useState} from "react";
import ApiServiceV2 from "../services/ApiServiceV2";
import * as yup from 'yup';
import {AnyObject} from "yup";
import {routes} from "./routes";

export const useUpdateData = <DataType extends object>(
    url: keyof typeof routes,
    current: DataType,
    id: string|number,
    validation: AnyObject
) => {
    const api = new ApiServiceV2()
    const [element, setElement] = useState<DataType>(current)
    const [files, setFiles] = useState<File[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isValid, setIsValid] = useState<boolean>(false)
    const [error, setError] = useState<string|null>(null)

    const changeProp = useCallback((data: Partial<DataType>) => {
        setElement(prevElement => ({...prevElement, ...data}))
    }, [])

    const changeFile = (file: File) => {
        setFiles([file])
    }

    useEffect(() => {
        yup.object(validation).validate(element).then(() => {
            setError(null)
            setIsValid(true)
        }).catch((reason) => {
            setError(reason)
            setIsValid(false)
        })
    }, [element, validation])

    const submit = async () => {
        setIsLoading(true)

        const response = await api.callApi(routes[url] + '/' + id, 'post', element, files)
        await setIsLoading(false)

        return response
    }

    return {
        error,
        element,
        isValid,
        isLoading,
        changeProp,
        changeFile,
        submit,
    }
}
